(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/play.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/play.js');

'use strict';

const {
  useContext,
  useEffect,
  useState,
  useMemo
} = React;
const {
  format
} = dateFns;
const {
  marketplace
} = svs.components;
const {
  PlayContext
} = svs.racing_game.components.playContext;
const {
  RaceServiceContext
} = svs.components.racing.race_service_state;
const {
  raceService
} = svs.racing;
const {
  RacePicker,
  BetModePicker,
  GameTypePicker,
  XpertMode,
  RegularMode,
  CouponSubscriber,
  useDisabledDraw,
  useDisabledDrawConstants,
  usePlayRedirects,
  PhotoFinish,
  NextRaceButtons
} = svs.racing_game.components.play;
const {
  raceNoLongerOpen,
  raceNotYetOpen,
  raceOpen,
  raceHasResult
} = svs.racing.common.statusUtil;
const {
  Socket
} = svs.components.lbUtils.socket;
const {
  resolveTimeZone
} = svs.components.lbUtils.helpers.formatDate;
const {
  withRouter
} = svs.app.ReactRouter;
const {
  getDrawOfGameType,
  gameTypeHasSystem,
  gameTypeHasMostPlayed,
  gameTypeHasQuinellaOdds,
  raceHasGameTypeXpert,
  gameTypeHasPressRatings
} = svs.racing.common.util;
const {
  couponMenuItems
} = svs.racing.common.constants;
const {
  setDefaultBetMode
} = svs.components.racing;
const {
  useNavigationActions,
  useNavigationState
} = svs.racing.navigation;
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const Play = () => {
  const {
    engine,
    race
  } = useContext(PlayContext);
  const [marketplaceAccount, setMarketplaceAccount] = useState(undefined);
  const {
    racecard,
    racecardDate,
    refreshRacecard,
    onRacecardUpdated
  } = useContext(RaceServiceContext);
  const raceSummaries = raceService.useRaceSummaries(racecard);
  useEffect(() => {
    const onAccountSelectorDataChange = _ref => {
      let {
        currentAccount
      } = _ref;
      setMarketplaceAccount(currentAccount);
    };
    if (marketplace && marketplace.accountSelector) {
      marketplace.accountSelector.helpers.observer.subscribe(onAccountSelectorDataChange, {
        emitCurrentValue: true
      });
    }
    return () => {
      marketplace.accountSelector.helpers.observer.unsubscribe(onAccountSelectorDataChange);
    };
  });
  const {
    toGameType,
    toXpert,
    toCouponItem,
    toPixMode
  } = useNavigationActions();
  const navigation = useNavigationState();
  const day = navigation.day || race && race.meeting && race.meeting.formattedDate || format(resolveTimeZone(new Date()), 'yyyy-MM-dd');
  const disabledGameType = useDisabledDraw();
  const isCurrentGameTypeDisabled = navigation.gameType === disabledGameType || disabledGameType === useDisabledDrawConstants.FULLY_DISABLED_RACE;
  const hasXpert = useMemo(() => raceHasGameTypeXpert(race, navigation.gameType), [race, navigation.gameType]);
  const hasSystem = useMemo(() => gameTypeHasSystem(navigation.gameType), [navigation.gameType]);
  const hasMostPlayed = useMemo(() => gameTypeHasMostPlayed(navigation.gameType), [navigation.gameType]);
  const hasQuinellaOdds = useMemo(() => gameTypeHasQuinellaOdds(navigation.gameType), [navigation.gameType]);
  const hasPressRatings = useMemo(() => gameTypeHasPressRatings(navigation.gameType), [navigation.gameType]);
  const currentDraw = getDrawOfGameType(race, navigation.gameType) || {};
  const isMarketplace = svs.racing_game.data.isRetailerAdmin || marketplaceAccount;
  const validatedCouponMenuItem = useMemo(() => {
    let validatedCouponMenuItem = navigation.couponMenuItem;
    if (race && raceNoLongerOpen(race)) {
      validatedCouponMenuItem = couponMenuItems.COUPON;
    } else if (navigation.couponMenuItem === couponMenuItems.PIX && !hasXpert) {
      validatedCouponMenuItem = couponMenuItems.COUPON;
    } else if (navigation.couponMenuItem === couponMenuItems.SYSTEM && !hasSystem) {
      validatedCouponMenuItem = couponMenuItems.COUPON;
    } else if (navigation.couponMenuItem === couponMenuItems.MOST_PLAYED && !hasMostPlayed) {
      validatedCouponMenuItem = couponMenuItems.COUPON;
    } else if (navigation.couponMenuItem === couponMenuItems.QUINELLA_ODDS && !hasQuinellaOdds) {
      validatedCouponMenuItem = couponMenuItems.COUPON;
    } else if (navigation.couponMenuItem === couponMenuItems.PRESS_RATINGS && !hasPressRatings) {
      validatedCouponMenuItem = couponMenuItems.COUPON;
    }
    return validatedCouponMenuItem;
  }, [navigation, hasSystem, hasXpert, hasMostPlayed, hasQuinellaOdds, hasPressRatings]);

  usePlayRedirects(race, navigation, toXpert, hasXpert);
  useEffect(() => {
    if (racecardDate === navigation.day && navigation.day) {
      return;
    }
    refreshRacecard(navigation.day);
  }, [navigation.day]);
  const betModeTracking = isXpert => {
    const betMode = isXpert ? 'PIX' : 'Eget spel';
    svs.components.analytics.trackEvent({
      category: 'Coupon',
      action: betMode,
      opt_label: 'Hästar'
    });
  };

  return React.createElement(React.Fragment, null, !isMarketplace && React.createElement(Socket, {
    onUpdate: result => {
      result && result.raceCard && onRacecardUpdated(result);
    },
    path: "/racing/1/racecard/".concat(day),
    sendInitialUpdate: true
  }, React.createElement(RacePicker, {
    raceSummaries: raceSummaries
  })), race && React.createElement(React.Fragment, null, React.createElement(NextRaceButtons, {
    raceSummaries: raceSummaries,
    systemType: engine.systemType
  }), raceNotYetOpen(race) && React.createElement("div", {
    className: "coupon-not-opened"
  }, "Spelet har inte \xF6ppnat \xE4n"), (raceNotYetOpen(race) || raceOpen(race)) && React.createElement(GameTypePicker, {
    currentDraw: currentDraw,
    gameType: navigation.gameType,
    marketplaceAccount: marketplaceAccount,
    race: race,
    setGameType: updatedGameType => {
      toGameType(updatedGameType);
    }
  }), raceOpen(race) && hasXpert && React.createElement(BetModePicker, {
    isXpert: navigation.isXpert,
    setIsXpert: updatedIsXpert => {
      setDefaultBetMode(updatedIsXpert, () => {
        isSelfService && betModeTracking(updatedIsXpert);
        toXpert(updatedIsXpert);
      });
    }
  }), React.createElement(CouponSubscriber, null, engine.isReady && (hasXpert && navigation.isXpert && raceOpen(race) ? React.createElement(XpertMode, {
    isDisabled: isCurrentGameTypeDisabled,
    key: navigation.gameType
  }) : React.createElement(RegularMode, {
    isDisabled: isCurrentGameTypeDisabled,
    selectedItem: validatedCouponMenuItem,
    selectedPixMode: navigation.pixMode,
    setPixMode: selectedPixMode => toPixMode(selectedPixMode),
    setSelectedItem: updatedCouponMenuItem => {
      toCouponItem(updatedCouponMenuItem);
    }
  }))), raceNoLongerOpen(race) && React.createElement("div", {
    className: "result-game-type-picker-holder"
  }, React.createElement(GameTypePicker, {
    currentDraw: currentDraw,
    gameType: navigation.gameType,
    marketplaceAccount: marketplaceAccount,
    race: race,
    setGameType: updatedGameType => {
      toGameType(updatedGameType);
    }
  })), raceHasResult(race) && React.createElement(PhotoFinish, {
    formattedDate: race.trackFormattedDate,
    trackId: race.trackUuid
  })));
};
svs.racing_game.components.play.Play = withRouter(Play);

 })(window);